module.exports = __webpack_public_path__ + "static/media/cover2.958e1400.png";